import { scan } from "@pdfking/rfunc"
import importer from "@pdfking/translations/importer"
import manifest from "@pdfking/translations/manifest"
import { reactive } from "vue"
export const get_translations = (library, lang) => {
  const imp = importer[lang || manifest.language][library]
  return imp().then(m => m.default)
}
export default (names, lang) => {
  const translations = reactive({})
  scan(library => {
    translations[library] = {}
    get_translations(library, lang).then(res => (translations[library] = res))
  }, names || manifest.libraries)
  return translations
}
